<template>
  <div>
    <form id="form" @submit.prevent="">
      <div class="form-group">
        <label>وضعیت</label>
        <div class="radio-inline">
          <label class="radio">
            <input type="radio" value="1" v-model="form.status" />
            <span></span>
            باز
          </label>
          <label class="radio">
            <input type="radio" value="0" v-model="form.status" />
            <span></span>
            بسته
          </label>
        </div>
        <span class="form-text text-muted">choose plug status</span>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "VLV",
  data() {
    return {
      form: {}
    };
  },
  computed: {
    ...mapGetters(["deviceTypes", "device"]),
    originalForm() {
      return {
        id: this.device.id,
        name: this.device.name,
        status: this.device.status.toString()
      };
    }
  },
  beforeMount() {
    this.form = _.cloneDeep(this.originalForm);
  },
  watch: {
    form: {
      handler() {
        // if (_.isEqual(this.form, this.originalForm) === false) {
        this.$emit("change-form", this.form.status);
        // }
      },
      deep: true
    }
  }
};
</script>
